import { render } from "./KpiSubCategories.vue?vue&type=template&id=5b3f2c23&scoped=true"
import script from "./KpiSubCategories.vue?vue&type=script&lang=js"
export * from "./KpiSubCategories.vue?vue&type=script&lang=js"

import "./KpiSubCategories.vue?vue&type=style&index=0&id=5b3f2c23&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3f2c23"]])

export default __exports__